<div class="au-dialog-container">
	<h2 class="au-dialog-title">{{ 'change_floor_name' | translate }}</h2>
	<mat-icon mat-dialog-close matRipple class="close-icon">close</mat-icon>
	<div class="au-dialog-content au-forms">
		<mat-form-field hideRequiredMarker class="m-t-m width-100">
			<input
				type="text"
				matInput
				[formControl]="control"
				[placeholder]="'floor_name' | translate"
			/>

			<mat-error>
				@if (control.errors?.required) {
					<span>{{ 'required' | translate }}</span>
				}
			</mat-error>
		</mat-form-field>
	</div>
</div>
<mat-dialog-actions>
	<au-techno-btn mat-dialog-close>{{ 'cancel' | translate }}</au-techno-btn>
	<button
		matRipple
		class="au-btn m-l-sm uppercase save-button"
		[disabled]="!control.valid"
		(click)="renameApproved()"
	>
		{{ 'save' | translate }}
	</button>
</mat-dialog-actions>
